import { DeseretBookCMS, formatTheme, formatMediaQuery } from '@deseretbook/cms'

let ref
let accessToken

// Load the preview cookie if the user has been given one.
if (window.Cookies) {
  ref = window.Cookies.get('io.prismic.preview')
}

// Load the access token if the user has been given one.
if (window.sessionStorage && window.sessionStorage.getItem) {
  accessToken = window.sessionStorage.getItem('dbcom:prismic:token')
}

export default new DeseretBookCMS({
  formatTheme,
  formatMediaQuery,
  ref,
  accessToken,
})
